// extracted by mini-css-extract-plugin
export default {"twitter-share-link":"twitter-share-link--mp-UyPZv","twitterShareLink":"twitter-share-link--mp-UyPZv"};